import { Points } from './Points';
export default Points;
